module.exports = __webpack_public_path__ + "static/media/bg-1.b9bd5fd1.png";